import React, { useRef } from "react";
import { Checkbox, Switch } from "@material-ui/core";
import PencilIcon from "../../../components/Icon/Pencil";
import AtivaIcon from "../../../components/Icon/AtivaIcon";
import DuplicaIcon from "../../../components/Icon/DuplicaIcon";
import DesativaIcon from "../../../components/Icon/DesativaIcon";
import PopperCustomMenu from "../../../components/Popper/PopperCustomMenu";
import string from "../../../utils/string";

export const tabsModal = {
  CONVENIO: 0,
  PRODUTO: 1,
};

export const optionsTipo = [
  {
    label: "Procedimento",
    value: "PROCEDIMENTO",
  },
  {
    label: "Odontológico",
    value: "ODONTOLOGICO",
  },
];

export const menuOpcoesPopper = (options) => {
  const { idPrefix = 'cfg', rowId } = options;
  const optionsMenu = [
    {
      ativo: options.isEdit,
      label: "Editar",
      onClick: () => options?.functions?.handleEdit(),
      icon: <PencilIcon size="24" color="#505050" />,
      id: `${idPrefix}-btn-edi-${rowId}`,
    },
    {
      ativo: true,
      label: "Duplicar",
      onClick: () => options?.functions?.handleDuplicar(),
      icon: <DuplicaIcon size="24" color="#505050" />,
      id: `${idPrefix}-btn-dup-${rowId}`,
    },
    {
      ativo: options.desativado,
      label: "Ativar",
      onClick: () => options?.functions?.handleAtivar(),
      icon: <AtivaIcon size="24" color="#505050" />,
      id: `${idPrefix}-btn-ati-${rowId}`,
    },
    {
      ativo: !options.desativado,
      label: "Desativar",
      onClick: () => options?.functions?.handleDesativar(),
      icon: <DesativaIcon size="24" color="#505050" />,
      id: `${idPrefix}-btn-des-${rowId}`,
    },
  ];
  return optionsMenu;
};

export const menuOpcoesMensagens = (options) => {
  const optionsMenuShort = [
    {
      ativo: options.isEdit,
      label: "Editar",
      onClick: () => options?.functions?.handleEdit(options.element.id),
      icon: <PencilIcon id={`cfg-msg-ico-edi-${options.element.id}`} size="24" color="#505050" />,
    },
  ];
  return optionsMenuShort;
}

const PopperMenu = ({ row, functions, idPrefix = 'cfg' }) => {
  const ref = useRef(null);
  const handleCloseWithAction = (fn) => {
    return () => {
      ref?.current && ref.current.closePopper()
      fn(row.id)
    }
  }


  return (
    <PopperCustomMenu
      id={`${idPrefix}-pop-aca-${row.id}`}
      menuOpcoes={menuOpcoesPopper({
        functions: {
          handleEdit: handleCloseWithAction(functions?.handleEditar),
          handleDuplicar: handleCloseWithAction(functions?.handleDuplicar),
          handleDesativar: handleCloseWithAction(functions?.handleDesativar),
          handleAtivar: handleCloseWithAction(functions?.handleAtivar),
        },
        desativado: !row.ativo,
        isEdit: true,
        idPrefix,
        rowId: row.id,
      })}
      ref={ref}
    />
  );
};

export const columnsProcedimentos = ({ functions, selection }) => {
  const columns = [];
  const { procedimentos, selectedItems } = selection;
  const procedimentosAtivos = procedimentos?.filter(p => p.ativo) || [];
  const todosAtivosSelecionados = procedimentosAtivos.length > 0 && 
    procedimentosAtivos.every(p => selectedItems.some(item => item.id === p.id));
  
  if (selection) {
    columns.push({
      Header: (
        <Checkbox
          id="cfg-pro-chk-all"
          color="primary"
          checked={todosAtivosSelecionados}
          disabled={procedimentosAtivos.length === 0}
          onChange={selection.onSelectAll}
        />
      ),
      getValue: (row) => {
        if (!row.ativo) return null;
        return (
          <Checkbox
            id={`cfg-pro-chk-${row.id}`}
            color="primary"
            checked={selection.selectedItems.some(item => item.id === row.id)}
            onChange={() => selection.onSelect(row)}
          />
        );
      },
      isClick: true,
    });
  }
  
  columns.push(
    {
      Header: "Nome do procedimento",
      field: "nome",
      getValue: (row) => row.nome,
    },
    {
      Header: "Descrição",
      field: "tuss22ProcedimentoEventoSaude.codigoTermo",
      getValue: (row) => row.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao,
    },
    {
      Header: "Status",
      field: "ativo",
      getValue: (row) => <Switch id={`cfg-pro-swt-sta-${row.id}`} checked={row.ativo} color="primary" />,
    },
    {
      Header: "Ação",
      isClick: true,
      getValue: (row) => <PopperMenu row={row} functions={functions} idPrefix="cfg-pro" />,
    }
  );
  
  return columns;
};


export const columnsMensagens = ({ functions,}) => [
  {
    Header: "Mensagens",
    getValue: (row) => {
      return (
        <div>{string.truncate(row.nome, 70)}</div>
      )
    }
  },
  {
    Header: "Status",
    field: "ativo",
    getValue: (row)=> 
    <Switch id={`cfg-msg-swt-sta-${row.id}`} disabled={row.tipoPadrao} checked={row.ativo} color="primary" />
  },
  {
    Header: "Ação",
    isClick: true,
    getValue: (row) => {
      return (
        <PopperCustomMenu
          id={`cfg-msg-pop-aca-${row.id}`}
          colorButton={{ background: "transparent" }}
          menuOpcoes={menuOpcoesMensagens({
            functions: {
              handleEdit: functions.handleEdit,
            },
            desativado: !row.ativo,
            isEdit: true,
            element: row,
          })}
          closePopperAfterClickOption
        />
      );
    },
  },
];

export const columnsConfiguracoes = ({
  functions,
  headerNome,
  isDescricao,
  idPrefix = 'cfg-con',
}) => [
    {
      Header: headerNome,
      field: isDescricao ? "descricao" : "nome",
      getValue: (row) => row.descricao || row.nome,
    },
    {
      Header: "Status",
      field: "ativo",
      getValue: (row) => <Switch id={`${idPrefix}-swt-sta-${row.id}`} checked={row.ativo} color="primary" />,
    },
    {
      Header: "Ação",
      isClick: true,
      getValue: (row) => <PopperMenu row={row} functions={functions} idPrefix={idPrefix} />,
    },


  ];

